'use strict'

export let english_release={
  Overview: {
    fields: {
      summary: {
        help: "Have any major milestones just passed, or are there any in the near future? Are there any resent successes or break throughs? What are currently the main challenges? What is the general health condition?",
        description: "Describe the overall status. Assume the reader has not read the previous report or know any details up front."
      },
      performedAchivements: {
        help: "What type of work was execution or completed this period? Which tasks, epics or topics were planned to be completed this period? Was any tasks planned to be completed but was not completed this period? Was any corrective actions taken during the period?",
        description: "Describe the work done and the goals achieved this period"

      },
      plannedAchivements: {
        help: "What type of work will be in execution or will be completed the coming period? Which tasks, epics or topics are planned to be completed this period? Any corrective actions planned for the coming period?",
        description: "Describe the work to be done and the goals set for the next period"
      },

      benefits: {
        help: "Are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case?",
        description: "Describe to what extent the work is resulting the in benefits assumed or planned."
      },
      time: {
        help: "What is the latest forecast on completing the current release, and how does it compare to the communicated roadmap?",
        description: "Describe how we are doing compared to the timeline set and communicated for this release"
      },
      cost: {
        help: "How much is spent to date in the current release, what is forecasted to be spent this release and what is currently the approved spending for the release?",
        description: "Describe how we are doing compared to the cost planned for this release."
      },

      quality: {
        help: "Have products delivered this period met the agreed quality criteria? Have the acceptance methods (testing, reviews...) for the products this period been applied as agreed? Have the products produced to date in the release met the agreed quality criteria?",
        description: "Describe to what extent we are meeting the planned functionalities and requirements of the release"
      },
      scope: {
        help: "Were the tasks, epics or user stories for this period identified and well defined - including composition and quality criteria? Are there any changes to the scope?",
        description: "Describe how the release is performing against the agreed scope"
      },

      risk: {
        help: "What is the current risk level in the release and how is it matching the stakeholders risk appetite or expectations? What are the most important risks and what actions are taken?",
        description: "Describe how the current risk level is compared to the agreed or commonly understood risk appetite"
      }
    }
  },
};



// WEBPACK FOOTER //
// ./views/progress/labels/english_release.js